import React, { useCallback } from 'react';

import { eventPreventDefault, stopEventPropagation } from '@lyearn/core/utils/events';
import { useTranslation } from '@lyearn/i18n';
import { Trash2Outline } from '@lyearn/icons';
import { Input, LinkButton } from '@lyearn/ui';

import { selectFormEditorOptionsItemStyles } from './styles';
import { SelectFormEditorOptionsItemProps } from './types';

function SelectFormEditorOptionsItem(props: SelectFormEditorOptionsItemProps) {
  const { allowPartialUpdates, canDelete, index, option, onChange, onDelete: onDeleteProp } = props;
  const { t } = useTranslation();

  const onChangeValue = useCallback(
    (nextValue: any) => {
      onChange({ ...option, optionText: nextValue });
    },
    [onChange, option],
  );

  const onDelete = useCallback(
    (event: any) => {
      eventPreventDefault(event);
      stopEventPropagation(event);
      onDeleteProp(option.optionId);
    },
    [onDeleteProp, option.optionId],
  );

  const renderEndAdornment = () =>
    allowPartialUpdates || !canDelete ? null : (
      <LinkButton className="py-2 px-4 opacity-0" onClick={onDelete}>
        <Trash2Outline fillColorToken="icon-secondary" />
      </LinkButton>
    );

  return (
    <Input
      className={selectFormEditorOptionsItemStyles}
      endAdornment={renderEndAdornment()}
      placeholder={t('Database:OptionItemPlaceholder', { index: index + 1 })}
      size="large"
      value={option.optionText}
      onChangeText={onChangeValue}
    />
  );
}

export default SelectFormEditorOptionsItem;
